import { CoreModel } from '../core/core.model';
export class DatatableColumnModel extends CoreModel {
/**
 * Column name
 */
name?: string;
/**
 * Row property name by which rows will be sorted
 */
sortBy?: string;
/**
 * Column width
 */
width?: string;
/**
 * Column header cell alignment
 */
headerAlignment?: string;
/**
 * Column row cell alignment
 */
cellAlignment?: string;
/**
 * @hidden
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}

function DatatableColumnModel_tsickle_Closure_declarations() {
/**
 * Column name
 * @type {?}
 */
DatatableColumnModel.prototype.name;
/**
 * Row property name by which rows will be sorted
 * @type {?}
 */
DatatableColumnModel.prototype.sortBy;
/**
 * Column width
 * @type {?}
 */
DatatableColumnModel.prototype.width;
/**
 * Column header cell alignment
 * @type {?}
 */
DatatableColumnModel.prototype.headerAlignment;
/**
 * Column row cell alignment
 * @type {?}
 */
DatatableColumnModel.prototype.cellAlignment;
}

